import { render, staticRenderFns } from "./FullWordCloud.vue?vue&type=template&id=795dd7be&scoped=true&"
import script from "./FullWordCloud.vue?vue&type=script&lang=js&"
export * from "./FullWordCloud.vue?vue&type=script&lang=js&"
import style0 from "./FullWordCloud.vue?vue&type=style&index=0&id=795dd7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dd7be",
  null
  
)

export default component.exports